"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = void 0;
exports.formatToShort = formatToShort;
exports.getIdFromSlug = void 0;
exports.getRandomInt = getRandomInt;
exports.isWebview = isWebview;
exports.renderArticleContent = void 0;
var _cookies = require("@kiwicom/cookies");
const MAX_32_BIT_SIGNED_INT = Math.pow(2, 31) - 1;
const getIdFromSlug = slug => {
  if (slug == null) {
    return 0;
  }
  const [articleId] = slug.split('-').slice(-1);
  if (!isNumericString(articleId)) {
    return 0;
  }
  if (Number(articleId) > MAX_32_BIT_SIGNED_INT) {
    return 0;
  }
  return Number(articleId);
};
exports.getIdFromSlug = getIdFromSlug;
const renderArticleContent = _ref => {
  let {
    rawContent,
    locale,
    auth,
    bid
  } = _ref;
  if (rawContent == null) {
    return '';
  }
  let modifiedContent = transformYoutubeEmbedLinksToIframes(setTargetToAnchorLinks(rawContent, '_blank'));
  modifiedContent = modifiedContent.replace(/https:\/\/www.kiwi.com\/?([A-Za-z]{0,2})\/help/gi, `https://www.kiwi.com/${locale}/help`);
  if ((auth === null || auth === void 0 ? void 0 : auth.type) !== 'token') {
    return modifiedContent;
  }
  return replaceAccountSlugWithMMBSlug(modifiedContent, bid, auth === null || auth === void 0 ? void 0 : auth.token);
};
exports.renderArticleContent = renderArticleContent;
const debounce = (callback, wait) => {
  let timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => callback.apply(null, args), wait);
  };
};
exports.debounce = debounce;
function isNumericString(value) {
  return !isNaN(parseFloat(value)) && isFinite(parseFloat(value));
}
function transformYoutubeEmbedLinksToIframes(rawContent) {
  return rawContent.replace(/(?<youtubeURL>https?:\/\/www.youtube.com\/embed\/[a-zA-Z0-9_-]+)/g, '<div class="videoContainer"><iframe class="videoIframe" src="$<youtubeURL>" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"></iframe></div>');
}
function setTargetToAnchorLinks(rawHtml, target) {
  return rawHtml.replace(/<a href=/g, `<a target="${target}" href=`);
}
function replaceAccountSlugWithMMBSlug(rawHtml, bid, token) {
  const tokenSlug = token ? `${token}/` : '';
  const bidSlug = bid ? `${bid}/` : '';
  return rawHtml.replace(/(https?:\/\/[^\s]*kiwi\.com)[^\s]*\/?(content)?\/account/g, `$1/manage/${bidSlug}${tokenSlug}`.substring(0, `$1/manage/${bidSlug}${tokenSlug}`.length - 1));
}
function formatToShort(dateString, localeId) {
  if (dateString == null || dateString.length === 0) return '';
  const now = new Date(Date.now());
  const date = new Date(removeTimezoneOffset(dateString));
  const isSameYear = now.getFullYear() === date.getFullYear();
  const options = {
    day: 'numeric',
    month: 'short',
    ...(!isSameYear && {
      year: 'numeric'
    })
  };
  return date.toLocaleString(localeId, options);
}
function removeTimezoneOffset(dateString) {
  const timezonePortionLength = 6;
  const gmtTimeIndicator = '.';
  return dateString.includes(gmtTimeIndicator) ? dateString.split(gmtTimeIndicator)[0] : dateString.substring(0, dateString.length - timezonePortionLength);
}
function getRandomInt(min, max) {
  const $min = Math.ceil(min);
  const $max = Math.floor(max);
  return Math.floor(Math.random() * ($max - $min) + $min);
}
function isWebview() {
  if (typeof window === 'undefined') {
    return false;
  }
  const urlSearchParams = new URLSearchParams(location.search);
  const hasWebviewQueryParam = Boolean(urlSearchParams.get('ui'));
  const hasWebviewSetInUrl = urlSearchParams.get('ui') === 'webview';
  const hasWebviewSetInCookie = (0, _cookies.load)(_cookies.Cookie.UI) === 'webview';
  return hasWebviewSetInUrl || !hasWebviewQueryParam && hasWebviewSetInCookie;
}